import { render } from "./finalStepAdmin.vue?vue&type=template&id=1e31489c"
import script from "./finalStepAdmin.vue?vue&type=script&lang=js"
export * from "./finalStepAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__